module.exports = __webpack_public_path__ + "static/media/fortnox-logo.0c61e602.svg";